module.exports = __webpack_public_path__ + "img/aquatic-staff-4.f6dbdf99.jpg";